import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import WebRotator from '@consteed/frontend/components/web-rotator'

const Model3D = ({id, alt, configFileURL}) => {
    const styles = {
        icon: {
            width: '100%',
            height: '60px',
            background: `url(${getAssetUrl('static/img/global/360.jpg')}) center center no-repeat`,
            backgroundSize: '60px',
            position: 'absolute',
            bottom: '10px',
            left: '0',
            zIndex: '9'
        }
    }
    return (
        <Box className={'pdcOuterBox'} position={'relative'} pb="60px !important">
            <AspectRatio ratio={1}>
                <Box height={'100%'} width={'100%'}>
                    <Box className={'pdcOuterBox'} height={'100%'}>
                        <WebRotator id={id} configFileURL={configFileURL} alt={alt} />
                    </Box>
                </Box>
            </AspectRatio>
            <Box {...styles.icon} />
        </Box>
    )
}

Model3D.propTypes = {
    id: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    configFileURL: PropTypes.string
}

export default Model3D
